export default {
    kn_dashboard_url: 'https://helpcenter.brainspro.com/es/',
    kn_create_user_url: 'https://helpcenter.brainspro.com/es/articles/5713368-como-dar-de-alta-a-un-estudianteL',
    kn_custom_domain_url: 'https://helpcenter.brainspro.com/es/articles/5712044-dominio-personalizado',
    kn_branding_url: 'https://helpcenter.brainspro.com/es/articles/5712060-logo-y-marca',
    kn_legal_url: "https://helpcenter.brainspro.com/es/articles/5713358-como-anadir-el-aviso-legal-a-la-web",
    kn_video_url: "https://helpcenter.brainspro.com/es/articles/8181845-como-cargar-videos"
}